// Vite bundles CSS through the JS entry point — this is what produces
// web/dist/assets/app-*.css and gives the stylesheet HMR in dev.
import '../styles/main.scss';

import gsap from 'gsap';
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";
gsap.registerPlugin(ScrollToPlugin);

import mobileNav from './modules/mobile-nav';
import nav from './modules/nav';
import search from './modules/search';
import team from './modules/team';
import filters from './modules/filters';
import carousel from './modules/carousel';
import homeCarousel from './modules/home-carousel';
import map from './modules/map';
import featured from './modules/featured';
import section from './modules/section';
import note from './modules/image-note';
import header from './modules/header';
import closePopup from './modules/popup';

// 2026 redesign. Each no-ops when its markup is absent, so these run safely
// alongside the pre-2026 nav/carousel modules while templates are migrated.
import megaNav from './modules/mega-nav';
import homeHero from './modules/home-hero';
import peopleSpotlight from './modules/people-spotlight';
import reveal from './modules/reveal';
import podcastBar from './modules/podcast-bar';
import faqs from './modules/faqs';

mobileNav.init();
nav.init();
filters.init();
section();
note();
header();
closePopup();

megaNav();
reveal();
// Not in the `load` handler below: the controls it wires up are on screen from
// the first paint, and waiting for every image meant they sat inert for a beat.
peopleSpotlight();
faqs();

// if tab key is used, add class to show outline styles
function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add('user-is-tabbing');
    window.removeEventListener('keydown', handleFirstTab);
  }
}

window.addEventListener('keydown', handleFirstTab);

if (history.scrollRestoration) {
  history.scrollRestoration = 'manual';
}

window.addEventListener('load', (e) => {
  search.init();
  team.init();
  carousel.init();
  homeCarousel();
  homeHero();
  map.init();
  featured();
  podcastBar();

  if (window.location.hash) {
    const selector = window.location.hash;
    const matching = document.querySelector(selector);

    if (matching) {
      gsap.to(window, {
        duration: 0.5,
        scrollTo: {
          y: selector,
          x: 0
        }
      });
    }
  }
});

window.addEventListener('popstate', (e) => {
  if (window.location.hash) {
    const selector = window.location.hash;
    const matching = document.querySelector(selector);

    if (matching) {
      gsap.to(window, {
        duration: 0.5,
        scrollTo: {
          y: selector,
          x: 0
        }
      });
    }
  }
});
